export const UiLoaderAnimationVanilla = ({ classes = '' }) => {
  return `<div class="ui-loader ${classes}">
    <svg
      class="ui-loader__icon"
      viewBox="0 0 100 100"
      fill="none"
    >
      <circle
        cx="50%"
        cy="50%"
        r="45"
        stroke="currentColor"
        class="ui-loader__circle"
      />
    </svg>
  </div>`
}
